import { render } from "./UEInsuranceTransferEditView.vue?vue&type=template&id=74478322&scoped=true"
import script from "./UEInsuranceTransferEditView.vue?vue&type=script&lang=js"
export * from "./UEInsuranceTransferEditView.vue?vue&type=script&lang=js"

import "./UEInsuranceTransferEditView.vue?vue&type=style&index=0&id=74478322&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74478322"]])

export default __exports__